import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

interface Props {
  open: boolean;
  entityLabel: string;
  consequence: string;
  onCancel: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export const ReverseConfirmDialog: React.FC<Props> = ({
  open, entityLabel, consequence, onCancel, onConfirm, loading,
}) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle>Reverse this {entityLabel}?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {consequence} Cannot be undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={loading}>Cancel</Button>
      <Button onClick={onConfirm} color="error" variant="contained" disabled={loading}>
        Confirm Reverse
      </Button>
    </DialogActions>
  </Dialog>
);
